/* eslint-disable */

import axios from 'axios';

export class APIServiceCovid {

    constructor() {}

    getDataGlobal = async (url) => {
        try {
          //   const { data : { confirmed, recovered, deaths, lastUpdate, image } } = await axios.get(url);
          //   return { confirmed, recovered, deaths, lastUpdate, image };
          let data = axios.get(url).then(response => response.data);
          return data;
        } catch (error) {
            console.log("getDataGlobal -> error", error);
        }
    }

    fetchCntryData = async (country) => {
        let changeableUrl = !country ? cntryApiUrl : `${cntryApiUrl}/countries/${country}`;
        try {
            const { data: { confirmed, recovered, deaths, lastUpdate } } = await axios.get(changeableUrl);
            return { confirmed, recovered, deaths, lastUpdate };
        } catch (error) {
            console.log("fetchCntryData -> error", error);
        }
    }

    getDataGlobalDetails = async (url, country, wrc) => {
        try {
            const data = await axios.get(url).then(response => response.data);
            if (wrc !== "world") {
                return data.filter((a, b) => a.countryRegion === country)
                .sort((a, b) => b.confirmed - a.confirmed)
                .map(result => ({
                    provinceState: result.provinceState,
                    confirmed: parseInt(result.confirmed),  
                    active: parseInt(result.active), 
                    activePct: `${Math.round((parseInt(result.active)/parseInt(result.confirmed))*100*100)/100} %`,
                    deaths: parseInt(result.deaths),
                    deathsPct: `${Math.round((parseInt(result.deaths)/parseInt(result.confirmed))*100*100)/100} %`,
                    // Combined: result.combinedKey,  
                    lastUpdate: result.lastUpdate,
                    Region: result.Region}))
            } else {
                return data.sort((a, b) => b.confirmed.total - a.confirmed.total)
                .map(result => ({
                    reportDate: result.reportDate,
                    confirmed: parseInt(result.confirmed.total),
                    // recovered: parseInt(result.recovered.total),
                    deaths: parseInt(result.deaths.total),
                    deathsPct: `${Math.round((parseInt(result.deaths.total)/parseInt(result.confirmed.total))*100*100)/100} %`,
                    // active: parseInt(result.active), 
                    deltaConfirmed: parseInt(result.deltaConfirmed),
                    deltaConfirmedPct: `${Math.round((parseInt(result.deltaConfirmed)/parseInt(result.confirmed.total))*100*100)/100} %`,
                    // deltarecovered: result.deltarecovered,
                    // peopletested: result.peopletested
                }))
            }
        } catch (error) {
            console.log("getDataGlobalDetails -> error", error);
        }
    }

    async getDataIndiaDtl(isTotal, url) {
        try {
            let data = await axios.get(url).then(response => response.data);
            const { statewise }  = data;
            data = statewise.filter((a, b) => isTotal ? a.statecode == "TT" : a.statecode != "TT");
            return data;
        } catch (error) {
            console.log("error-", error);
        }
    }

    filterState = (obj, rootvalue) => {
        let { [rootvalue]: { districtData: dd } } = obj
        return dd
    }

    flattenO = (obj, newindex) => {
        var result = {}
        Object.keys(obj).forEach(key => {
          if (typeof obj[key] !== "object") {
            flattenO(obj[key])
          } else {
            result[key] = obj[key]
            result[key][newindex] = key;
            result[key].activePct = Math.round((parseInt(result[key].active)/parseInt(result[key].confirmed)*100)*100)/100 + " %";
            result[key].recoveredPct = Math.round((parseInt(result[key].recovered)/parseInt(result[key].confirmed)*100)*100)/100 + " %";
            result[key].deceasedPct = Math.round((parseInt(result[key].deceased)/parseInt(result[key].confirmed)*100)*100)/100 + " %";
          }
      })
      return Object.values(result)
    }

    async getDataIndiaStateDtl(url, state) {
        try {
            let data = await axios.get(url).then(response => response.data);
            return data;
            
        } catch (error) {
            console.log("error-", error);
        }
    }

    async getCountryList(url) {
        try {
            const curl = `${url}/countries/`;
            let data = await axios.get(curl).then(response => response.data);
            const { countries } = data
            data = countries.filter ((a, b) => 1 == 1);
            return data;
        } catch (error) {
            console.log("error-", error);
        }
    }
}